"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
// import addIcon from '@assets/components/user/user-link-table/toolbar/add-icon.svg'
var actions_1 = __importDefault(require("../../../../actions"));
// import ContainedIconButton from './templates/ContainedIconButton'
// import useMinifiedActions from '../../../CreateUrlModal/helpers/minifiedActions'
var OvalContainedButton_1 = __importDefault(require("./templates/OvalContainedButton"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        createLinkButtonContainer: {
            marginLeft: theme.spacing(1.5),
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
        },
    });
});
var CreateLinkButton = function () {
    var _a = __read(react_i18next_1.useTranslation(), 1), t = _a[0];
    var dispatch = react_redux_1.useDispatch();
    var openCreateUrlModal = function () { return dispatch(actions_1.default.openCreateUrlModal()); };
    var classes = useStyles();
    return (react_1.default.createElement("span", { className: classes.createLinkButtonContainer },
        react_1.default.createElement(OvalContainedButton_1.default, { onClick: openCreateUrlModal }, t('button.createLink'))));
};
exports.default = CreateLinkButton;
